<template>
  <v-menu v-model="isOpen" :close-on-content-click="false">
    <template #activator="{ props }">
      <v-btn variant="outlined" density="compact" v-bind="props">
        <v-icon class="mr-2" icon="mdi-plus"></v-icon>
        <span class="font-weight-regular font-size-12">Учасник</span>
      </v-btn>
    </template>

    <v-card width="300">
      <v-card-text>
        <b-input
          v-model="searchStr"
          variant="plain"
          placeholder="Пошук..."
          prepend-icon="mdi-magnify"
          hide-details></b-input>

        <v-divider class="my-2"></v-divider>

        <div class="overflow-y-auto" style="max-height: 300px">
          <b-global-loader :loading="$loading.isLoading('getUserList')">
            <v-list-item
              v-for="user in userList"
              :key="user.id"
              class="px-3 py-2"
              @click="
                () => {
                  isOpen = false
                  $emit('create', user.id)
                }
              ">
              <template #prepend>
                <v-avatar class="mr-3" color="indigo-lighten-5" size="40">
                  <span
                    class="text-indigo-darken-1 font-weight-bold text-subtitle-2">
                    {{ user.name?.[0] + user.surname?.[0] }}
                  </span>
                </v-avatar>
              </template>
              <v-list-item-title class="text-subtitle-2 font-weight-bold">
                {{ getPersonName(user, { initials: true }) }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-size-13">
                {{ user.post || 'Посада відсутня' }}
              </v-list-item-subtitle>
            </v-list-item>

            <div v-if="!userList.length" class="text-disabled text-center py-5">
              Дані відсутні
            </div>
          </b-global-loader>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script setup lang="ts">
import { ref, shallowRef, watch } from 'vue'
import { BGlobalLoader } from 'best-modules/components'
import { handleAsync } from 'best-modules/plugins'
import { userList as userListRequest } from '@/requests/user'
import { debounce } from 'lodash'
import { getPersonName } from 'best-modules/utils'
import { User } from '@/utils/types/user'

defineOptions({
  name: 'CreateStageParticipant',
})
defineEmits<{
  (_name: 'create', _userId: number): void
}>()

const isOpen = ref<boolean>(false)
const searchStr = ref<string>('')

watch(isOpen, v => {
  if (!v) {
    searchStr.value = ''
  }
})

const userList = shallowRef<User[]>([])

const getUserList = (search: any = null) => {
  if (isOpen.value) {
    return handleAsync('getUserList', () => {
      return userListRequest({ search }).then(res => {
        userList.value = res.data
      })
    })
  }
}

watch(searchStr, debounce(getUserList, 500))

watch(isOpen, v => {
  if (!v) {
    searchStr.value = ''
  } else {
    getUserList()
  }
})
</script>
